import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect } from "react";
import useSnackbar from '../../../hooks/useSnackbar';
import { getTransactionCustomerRefundRefundMethod, getTransactionCustomerPaymentEvent } from '../../../api/transaction-type';
import { customerRefundPaymentEventTable, paymentMethodDepositsTable } from '../../../config/grid-column-defs';
import AgGridPaginatedTable from '../../../components/AgGridPaginatedTable';

import { slugMap } from '../../../config/slug-config';
import { useParams } from 'react-router-dom';
import { Box, Grid, CircularProgress, Tabs, Tab, Button } from '@mui/material';
import TabPanel from "../../../components/TabPanel";
import { GridComp6 } from "../../../components/GridComponents";
import { CustomCheckBoxComp126 } from "../../../components/CheckboxComp";
import PaymentEventViewDialog from "../../../components/PaymentEventView";

export default function CustomerRefundRefundMethod({ tabIndexP }) {
  const dispatch = useDispatch();
  const snackbar = useSnackbar();
  const { data: user } = useSelector(state => state.user);
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [subTabIndex, setSubTabIndex] = useState(0);
  const pageDetail = slugMap[params.slug];
  const [rowData, setRowData] = useState([]);
  const [paymentEventData, setPaymentEventData] = useState([]);

  const [open, setOpen] = useState(false);
  const [id, setId] = useState("");
  let obj = customerRefundPaymentEventTable.find((o) => o.headerName === "VIEW DETAILS");
  addAdditionalColumn(obj, dispatch);

  // const [tableRefreshCount, setTableRefreshCount] = useState(0);
  // function refreshTable () {  
  //     setTableRefreshCount(prev => prev + 1);
  // }

  useEffect(() => {
    if (user.token && tabIndexP === 1) {
      getTransactionDocRefundMethodData();
    }
  }, [tabIndexP]);

  const handleClickOpen = (id) => {
    setId(id);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  function addAdditionalColumn(obj, dispatch) {
    if (obj === undefined) {
      customerRefundPaymentEventTable.push({
        headerName: "VIEW DETAILS",
        field: "actions",
        resizable: true,
        minWidth: 120,
        cellRendererFramework: (params) => (
          <Button
            className="viewLink"
            onClick={() => {
              handleClickOpen(params.data.view);
            }}
          >
            View
          </Button>
        ),
      });
    }
  }

  async function getTransactionDocRefundMethodData() {
    setLoading(true);
    try {
      const { data } = await getTransactionCustomerRefundRefundMethod(user.token, { id: params.docNo });
      setLoading(false);
      setRowData(data.data.data);
    } catch (error) {
      console.log(error);
      setLoading(false);
      snackbar.showError("Error In Loading Data.");
      return { error: true }
    } finally {
      setLoading(false);
    }
  }

  // async function getTransactionCustomerRefundPaymentEventData(limit, offset) {
  //   try {
  //     const { data } = await getTransactionCustomerPaymentEvent(user.token, {
  //       id: params.docNo,
  //       limit, offset
  //     });
  //     setPaymentEventData(data.data.data);
  //     return { rows: data.data.data, total: data.data.total, error: false, };
  //   } catch (error) {
  //     console.log(error);
  //     return { error: true };
  //   } finally {
  //   }
  // }

  return (
    <>
      <Box className="viewBox sub-tab" sx={{ maxWidth: { xs: 320, sm: 480, md: "100%" }, bgcolor: '#fff' }}>
        <Tabs
          value={subTabIndex}
          // onChange={handleChange}
          onChange={(e, snv) => {
            setSubTabIndex(snv);
          }}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
          className="tabs-sub-bkg"
        >
          <Tab label={`Deposits ${"0.00"}`} />
        </Tabs>

        {/* Payment Events */}
        <TabPanel value={subTabIndex} index={0}>
          {tabIndexP === 1 ?
            <AgGridPaginatedTable
              // getTableRows={getTransactionCustomerRefundPaymentEventData}
              columns={paymentMethodDepositsTable} perPage={5} refreshCounter={0}
              onCellClicked={(params) => {
                if (params.colDef.field === "actions") {
                  setOpen(true);
                  setId(params.data.view);
                }
                return;
              }}
            />
            : <></>
          }
        </TabPanel>
        {/* Payment Events */}
      
      </Box>
      <PaymentEventViewDialog open={open} id={id} handleClose={handleClose} paymentEventData={paymentEventData} />
    </>
  )
}



